import React, { useEffect, useState } from "react";
import { fetchChildInfo, updateChildInfo } from "../../services/Api";
import { useToast } from '../../services/ToastContext';
import PopupWrapper from "../../components/PopupWrapper";
import { useRefresh } from "../../services/RefreshContext";

const EditChildForm = ({ isOpen, onClose, childID, title }) => {
  const { showToast } = useToast();
  const { triggerRefresh } = useRefresh();
  const [firstName, setFirstName] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [inputErrors, setInputErrors] = useState({
    inputFirstName: "",
  });

  useEffect(() => {
    const getChildInfo = async () => {
      if (childID) {
        const responseAccountInfo = await fetchChildInfo(childID);
        setFirstName(responseAccountInfo.childResults.FirstName);
      }
    };
    getChildInfo();

    // Reset form when closed
    return () => {
        if (!isOpen) {
        setFirstName("");
        setError("");
        }
    };
  }, [childID, isOpen]);

  const validateEditChildForm = () => {
    let valid = true;
    const newErrors = {
      inputFirstName: "",
    };

    if (!firstName.trim()) {
      newErrors.inputFirstName = "Child first name is required";
      valid = false;
    }

    setInputErrors(newErrors);
    return valid;
  };

  const handleEditChild = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!validateEditChildForm()) {
      setIsLoading(false);
      return;
    }

    try {
      await updateChildInfo(firstName, childID);
      triggerRefresh();
      showToast("Child Info Updated");
      onClose();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen || !childID) return null;

  return (
    <PopupWrapper isOpen={isOpen} onClose={onClose} title={title} isSecondary={true}>
      <form className="user">
        <div className="form-group">
          <input
            type="text"
            className="form-control form-control-user"
            id="firstNameInputEditChild"
            placeholder="First Name"
            value={firstName || ""}
            onChange={(e) => setFirstName(e.target.value)}
          />
          {inputErrors.inputFirstName && (
            <p className="text-danger">{inputErrors.inputFirstName}</p>
          )}
        </div>

        {error && <p className="text-danger">{error}</p>}

        <div className="popupButtons">
          <button
            type="button"
            className="cancel-btn p-3 grey-color"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="submit"
            className={`confirm-btn p-3${isLoading ? " opacity-50 cursor-not-allowed" : ""}`}
            disabled={isLoading}
            onClick={handleEditChild}
          >
            {isLoading ? "Updating..." : "Update Child"}
          </button>
        </div>
      </form>
    </PopupWrapper>
  );
};

export default EditChildForm;